import Handlebars from 'handlebars'
import dayjs from 'dayjs'
import { toast } from 'react-toastify'
import { convertDocumentAndUploadFile, fileToBase64 } from './documentManager'
import { addObject } from '../api/apiClientCrud'

const generateToastId = () => Math.floor(100000000 + Math.random() * 900000000)

const updateToast = (toastId, { type, render, autoClose = 2000 }) => {
  toast.update(toastId, {
    type,
    render,
    autoClose,
    isLoading: false
  })
}

export const compileTemplate = (data, template) => {
  if (!template) return ''
  const compiled = Handlebars.compile(template)
  return compiled(data)
}

export const sendMail = async (mailOptions) => {
  const toastId = generateToastId()
  toast.loading('Envoi en cours', { toastId })

  try {
    const res = await addObject('sendMail', { mailOptions })

    if (res.status === 200) {
      updateToast(toastId, { type: 'success', render: 'Email envoyé' })
      return true
    }
    updateToast(toastId, { type: 'error', render: 'Email non envoyé' })
    return false
  } catch {
    updateToast(toastId, { type: 'error', render: 'Email non envoyé' })
    return false
  }
}

const generateAttachment = async ({ component, filename, user, type, collection, object, setFiles }) => {
  try {
    const file = await convertDocumentAndUploadFile(component, filename, user, type, collection, object, setFiles)
    const base64 = await fileToBase64(file)

    return {
      filename: `${filename}.pdf`,
      content: base64,
      encoding: 'base64'
    }
  } catch (error) {
    toast.error('Erreur lors de la génération du PDF', { autoClose: 3000 })
    throw error
  }
}

const buildEmailPayload = ({ from, to, subject, html, attachment, parentId, fromName, createdBy }) => ({
  from,
  mailbox: from,
  to,
  subject,
  html,
  attachments: [attachment],
  priority: 'normal',
  attachDataUrls: true,
  fromName,
  parentId,
  createdBy
})

export const sendDocumentEmail = async ({
  type = 'document',
  objectType,
  object,
  user,
  company,
  customer,
  template,
  component,
  setFiles,
  subjectPrefix = 'Votre document',
  statusToUpdate = null,
  updateStatus = () => {}
}) => {
  try {
    const numberField = `${objectType}_number`
    const dateField = `${objectType}_date`
    const collection = `${objectType}s`

    const filename = `${type}_${object[numberField] ?? object.number ?? 'doc'}`

    const formattedObject = {
      ...object,
      [dateField]: dayjs(object[dateField]).format('DD/MM/YYYY')
    }

    const attachment = await generateAttachment({
      component,
      filename,
      user,
      type: objectType,
      collection,
      object,
      setFiles
    })

    const emailHTML = compileTemplate({ [objectType]: formattedObject, company, customer }, template)

    const emailPayload = buildEmailPayload({
      from: user.email,
      to: customer.email,
      subject: `${subjectPrefix} ${object[numberField] ?? ''}`,
      html: emailHTML,
      attachment,
      parentId: customer.id,
      fromName: 'IT UP consult',
      createdBy: user.email
    })

    const mailSent = await sendMail(emailPayload)

    if (mailSent && statusToUpdate !== null && object.status < statusToUpdate) {
      updateStatus(statusToUpdate)
    }

    return mailSent
  } catch (error) {
    toast.error(`Erreur lors de l'envoi de l'email ${type}`, { autoClose: 3000 })
    return false
  }
}
